import React, {Component} from "react";
import {Col, Row, FormGroup} from "react-bootstrap";
import Radio from "./KnoaRadio";
import {withTranslation} from 'react-i18next';
import {
    checkBenchmarkWarning, createSliderWithBenchmark, disableSecondHandle,
    updateBaseTooltip, updateMainHandleColor, updateBenchmarkHandleColor,
    updateBenchmarkHandleVisibility, updateHandlesIndex, updateLimit,
    updateSliderColor, updateTooltips, updateValues, updateMainHandleId
} from "../../lib/noUiSliderCommon";
import {calculateBenchmarkDate, checkBenchmarkWarningAbsolute, getServerTimezoneDate, hideBenchmarkWarningAbsolute} from "../../lib/common";
import moment from "moment";
import {getWarningMessages} from "../../lib/notifications/messageUtils";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

class TimeframeSelection extends Component {
    constructor(props) {
        super(props);

        this.handleRadio = this.handleRadio.bind(this);
        this.handleSliderRelativeChange = this.handleSliderRelativeChange.bind(this);
        this.handleSliderRelativeSlide = this.handleSliderRelativeSlide.bind(this);
        this.handleSliderRelativeStart = this.handleSliderRelativeStart.bind(this);
        this.validAbsoluteStart = this.validAbsoluteStart.bind(this);
        this.validAbsoluteEnd = this.validAbsoluteEnd.bind(this);
        this.handleStartDateInputChange = this.handleStartDateInputChange.bind(this);
        this.handleEndDateInputChange = this.handleEndDateInputChange.bind(this);
        this.getPartOfDate = this.getPartOfDate.bind(this);

        //Layout
        const isCtxProject = this.props.context === 'project';
        this.layout = {
            colContainer: { md: isCtxProject ? 10 : 12 },
            colContainerOffset: { md: isCtxProject ? 1 : 0 },

            // Wider layout for radio + slider
            colRadioRelative: { sm: 12, md: 4 },
            colSliderRelative: { sm: 12, md: 8 },

            // Absolute layout
            colRadioAbsolute: { sm: 12, md: 4 },
            colDateAbsolute: { sm: 12, md: 4 },
            colSpacer: { sm: 12, md: 4 },
            colBenchmarkSummary: { sm: 12, md: 8 }
        };
    }

    getPartOfDate(date, part) {
        if (part === "month") {
            return date.getMonth();
        } else if (part === "day") {
            return date.getDate();
        } else if (part === "year") {
            return date.getFullYear();
        } else return date;
    }

    handleRadio(event) {
        const target = event.target;
        this.props.handleTimeFilterUpdate(target.name, target.getAttribute('data-datarange'), target.id);
    };

    handleSliderRelativeStart() {
        const sliderRelative = document.getElementById('sliderRelative' + this.props.filterType);
        updateBenchmarkHandleVisibility(sliderRelative, 'hidden');
    }

    handleSliderRelativeSlide() {
        const sliderRelative = document.getElementById('sliderRelative' + this.props.filterType);
        const baseValue = sliderRelative.noUiSlider.get()[0];
        let timeFilterObj = this.props.filterType === "Current" ? this.props.timeFilter.current : this.props.timeFilter.historical;
        updateSliderColor(sliderRelative, baseValue, timeFilterObj.limit, "RELATIVE");
        updateBaseTooltip(sliderRelative);
    }

    handleSliderRelativeChange() {
        const sliderRelative = document.getElementById('sliderRelative' + this.props.filterType);
        const value = parseInt(sliderRelative.noUiSlider.get()[0]);

        updateMainHandleColor(sliderRelative, "RELATIVE");
        updateBenchmarkHandleColor(sliderRelative, value, sliderRelative.noUiSlider.options.range.max, "RELATIVE");
        checkBenchmarkWarning(sliderRelative, this.props.filterType, getWarningMessages(this.props.t, 'benchmarkSlider', null));
        updateBenchmarkHandleVisibility(sliderRelative, 'visible');

        this.props.handleTimeFilterUpdate("relativeSlider", this.props.filterType, value);
    }

    handleStartDateInputChange = (date) => {
        const momentS = moment(date);
        if (momentS.isValid()) {
            this.props.handleTimeFilterUpdate("absoluteStartDate", this.props.filterType, momentS);
        }
    };

    handleEndDateInputChange = (date) => {
        const momentE = moment(date);
        if (momentE.isValid()) {
            this.props.handleTimeFilterUpdate("absoluteEndDate", this.props.filterType, momentE);
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        let tempFilterChangeIdentifier = window.sessionStorage.getItem("lastChangedFilter");
        return tempFilterChangeIdentifier === null || tempFilterChangeIdentifier?.startsWith("TIME");
    }

    validAbsoluteStart(current) {
        const currentMoment = moment(current); // wrap native Date

        if (this.props.filterType === "Current") {
            return currentMoment.isSameOrAfter(this.props.timeFilter.current.absoluteCalendarStart, 'day');
        } else if (this.props.filterType === "Historical") {
            return currentMoment.isSameOrAfter(this.props.timeFilter.historical.absoluteCalendarStart, 'month');
        }

        return false;
    }

    validAbsoluteEnd(current) {
        const currentMoment = moment(current); // wrap native Date

        if (this.props.filterType === "Current") {
            return currentMoment.isSameOrAfter(this.props.timeFilter.current.absoluteStartDate, 'day');

        } else if (this.props.filterType === "Historical") {
            return currentMoment.isSameOrAfter(this.props.timeFilter.historical.absoluteStartDate, 'month')
        }

        return false;
    }

    componentDidUpdate() {
        if (Object.keys(this.props.timeFilter).length > 0) {
            const sliderRelative = document.getElementById('sliderRelative' + this.props.filterType);
            const startDateAbsolute = document.getElementById('startDateAbsolute' + this.props.filterType);
            const endDateAbsolute = document.getElementById('endDateAbsolute' + this.props.filterType);
            let timeFilterObj = this.props.filterType === "Current" ? this.props.timeFilter.current : this.props.timeFilter.historical;

            if (timeFilterObj.limit) {
                updateLimit(sliderRelative, timeFilterObj.limit);
            }

            if (timeFilterObj.relativeNew) {
                updateValues(sliderRelative, timeFilterObj.relativeNew);
            }

            updateHandlesIndex(sliderRelative);
            updateTooltips(sliderRelative, this.props.t('report.filter:basePeriod'), this.props.t('report.filter:benchmarkPeriod'));
            updateSliderColor(sliderRelative, timeFilterObj.relativeNew, timeFilterObj.limit, timeFilterObj.selectedTimePeriod);
            updateMainHandleColor(sliderRelative, timeFilterObj.selectedTimePeriod);
            updateBenchmarkHandleColor(sliderRelative, timeFilterObj.relativeNew, timeFilterObj.limit, timeFilterObj.selectedTimePeriod);
            checkBenchmarkWarning(sliderRelative, this.props.filterType, getWarningMessages(this.props.t, 'benchmarkSlider', null));

            if (this.props.isInstanceReport) {
                sliderRelative.setAttribute('disabled', true);
                sliderRelative.classList.remove("slider-primary");
                sliderRelative.classList.add("slider-disabled");
                startDateAbsolute.setAttribute('disabled', true);
                endDateAbsolute.setAttribute('disabled', true);
            } else if (timeFilterObj.selectedTimePeriod === 'RELATIVE') {
                //Enable/disable components
                sliderRelative.removeAttribute('disabled');
                sliderRelative.classList.remove("slider-disabled");
                sliderRelative.classList.add("slider-primary");
                startDateAbsolute.setAttribute('disabled', true);
                endDateAbsolute.setAttribute('disabled', true);

                //Hide warning if its displayed
                hideBenchmarkWarningAbsolute(this.props.filterType);
            } else if (timeFilterObj.selectedTimePeriod === "ABSOLUTE") {
                //Enable/disable components
                sliderRelative.setAttribute('disabled', true);
                sliderRelative.classList.remove("slider-primary");
                sliderRelative.classList.add("slider-disabled");
                startDateAbsolute.removeAttribute('disabled');
                endDateAbsolute.removeAttribute('disabled');

                //Check if warning should be displayed
                let absoluteStartDate = timeFilterObj.absoluteStartDate;
                let absoluteEndDate = timeFilterObj.EndDate;
                let absoluteBenchmarkLabel = calculateBenchmarkDate(absoluteStartDate, absoluteEndDate, this.props.filterType);
                const benchMarkStart = absoluteBenchmarkLabel.substr(0, absoluteBenchmarkLabel.indexOf(' '));
                checkBenchmarkWarningAbsolute(benchMarkStart, timeFilterObj.absoluteCalendarStart, this.props.filterType, getWarningMessages(this.props.t, 'benchmarkSlider', null));
            }
        }
    };

    componentDidMount() {
        //Slider ->
        const sliderRelative = document.getElementById('sliderRelative' + this.props.filterType);
        createSliderWithBenchmark(sliderRelative);
        disableSecondHandle(sliderRelative);
        updateMainHandleId(sliderRelative, 'sliderWarningText' + this.props.filterType);
        sliderRelative.noUiSlider.on('change', this.handleSliderRelativeChange);
        sliderRelative.noUiSlider.on('slide', this.handleSliderRelativeSlide);
        sliderRelative.noUiSlider.on('start', this.handleSliderRelativeStart);
        //<- Slider

        const startDateInput = document.getElementById('startDateAbsolute' + this.props.filterType);
        const endDateInput = document.getElementById('endDateAbsolute' + this.props.filterType);
        if (startDateInput) {
            //Center align dates
            startDateInput.style.textAlign = 'center';
            //Add aria-describedby to date inputs for accessibility
            startDateInput.setAttribute('aria-describedby', 'absoluteTimeWarningText' + this.props.filterType);
        }
        if (endDateInput) {
            endDateInput.style.textAlign = 'center';
            //Add aria-describedby to date inputs for accessibility
            endDateInput.setAttribute('aria-describedby', 'absoluteTimeWarningText' + this.props.filterType);
        }

        this.componentDidUpdate();
    }

    render() {
        const {filterType, timeFilter, absoluteStartError, absoluteEndError} = this.props;
        const {t} = this.props;

        let radioTimeframeOptions = "1";
        let selectedTimePeriod = "RELATIVE";
        let selectedValue = "";
        let unitRelative = "";
        let absoluteStartDate = getServerTimezoneDate();
        let absoluteEndDate = getServerTimezoneDate();
        let showMonthYearPicker= false;
        let dateFormat = "dd/MM/yyyy";
        let sliderRelativeString = "";
        let sliderRelativeString2 = "";
        let absoluteBenchmarkLabel = "";

        if (Object.keys(timeFilter).length > 0) {
            let timeFilterObj = filterType === "Current" ? timeFilter.current : timeFilter.historical;

            //Update date objects that may be in string format (this should be fixed so that they are not saved as a string)
            if (typeof (timeFilter.current.EndDate) === 'string') {
                timeFilter.current.EndDate = new Date(timeFilter.current.EndDate);
            }
            if (typeof (timeFilter.current.absoluteStartDate) === 'string') {
                timeFilter.current.absoluteStartDate = new Date(timeFilter.current.absoluteStartDate);
            }

            selectedTimePeriod = timeFilterObj.selectedTimePeriod;
            absoluteEndDate = timeFilterObj.EndDate;
            absoluteStartDate = timeFilterObj.absoluteStartDate;
            selectedValue = timeFilterObj.relativeNew;

            absoluteBenchmarkLabel = calculateBenchmarkDate(absoluteStartDate, absoluteEndDate, filterType);

            if (filterType === "Current") {
                unitRelative = selectedValue > 1 ? "days" : "day";
                dateFormat = "MM/dd/yyyy";
                sliderRelativeString = t('project:sliderStringRelative', {value: selectedValue, unit: unitRelative});
                sliderRelativeString2 = t('preferences:sliderString2', {value: selectedValue, unit: unitRelative});
            } else {
                unitRelative = selectedValue > 1 ? "months" : "month";
                showMonthYearPicker = true;
                dateFormat = "MM/yyyy";
                sliderRelativeString = t('project:sliderStringRelative', {value: selectedValue, unit: unitRelative});
                sliderRelativeString2 = t('preferences:sliderString2', {value: selectedValue, unit: unitRelative});
            }

            if (selectedTimePeriod === "RELATIVE") {
                radioTimeframeOptions = "1";
            } else if (selectedTimePeriod === "ABSOLUTE") {
                radioTimeframeOptions = "2";
            }
        }

        if (this.props.i18n.language === 'zh') {
            require('moment/locale/zh-cn');
        }

        return (
            <FormGroup
                role="group"
                aria-labelledby="timeframe"
                className={`timeSelectFG ${this.props.isInstanceReport ? 'report-filter-panel-instance' : ''}`}
            >
                {/* Relative Timeframe Block */}
                <Row className={this.props.context === 'project' ? 'mb-1' : ''}>
                    <Col className="ps-5" md={{ span: this.layout.colContainer.md, offset: this.layout.colContainerOffset.md }}>
                        {this.props.context === 'project' ? (
                            <h4 id="timeframe" className="knoa-region" tabIndex="-1">
                                {t('project:selectTimeframe')}
                            </h4>
                        ) : (
                            <Row className="card-filter-section-title">
                                <span id="timeframe">{t('report.filter:TimeFilters')}</span>
                            </Row>
                        )}

                        {/* Radio: Relative */}
                        <Row className="mb-2 mt-2">
                            <Col {...this.layout.colRadioRelative} className="d-flex">
                                <Radio
                                    number="RELATIVE"
                                    option="1"
                                    name="radioTimeframeOptions"
                                    onChange={this.handleRadio}
                                    value={radioTimeframeOptions}
                                    label={
                                        this.props.context === 'project'
                                            ? t('project:useRelativeTimeframe')
                                            : t('report.filter:RelativeTimeframe')
                                    }
                                    data-datarange={filterType}
                                    className={this.props.context === 'filterPanel' ? 'radioButtonTimeframe' : 'custom-radio-lg'}
                                    disabled={this.props.isInstanceReport}
                                    labelClass={this.props.context === 'project' ? 'timeframeLbl' : undefined}
                                />
                            </Col>

                            {/* Slider */}
                            <Col {...this.layout.colSliderRelative} className="mt-1">
                                <div
                                    ref={this.sliderRef}
                                    id={`sliderRelative${filterType}`}
                                    className="slider-primary position-relative mb-1"
                                    data-datarange={filterType}
                                />
                                {timeFilter && (
                                    <>
                                        <div className="timeSelectLabel" style={{ minHeight: '24px' }}>
                                            <span className={this.props.context === 'filterPanel' ? 'labelText' : 'labelTextLg'}>
                                              {sliderRelativeString}
                                            </span>
                                        </div>
                                        <div style={{ minHeight: '24px' }}>
                                            <span className={this.props.context === 'filterPanel' ? 'labelText' : 'labelTextLg'}>
                                                {sliderRelativeString2}
                                            </span>
                                        </div>
                                        <div
                                            id={`sliderWarning${filterType}`}
                                            className="timeSelectWarning"
                                            style={{ minHeight: '28px' }}
                                        >
                                            <span id={`sliderWarningText${filterType}`} className="benchmarkWarning"></span>
                                        </div>
                                    </>
                                )}
                            </Col>
                        </Row>
                    </Col>
                </Row>

                {/* Absolute Timeframe Block */}
                <Row>
                    <Col className="ps-5" md={{ span: this.layout.colContainer.md, offset: this.layout.colContainerOffset.md }}>
                        <Row className="mb-2">
                            {/* Radio Button */}
                            <Col {...this.layout.colRadioAbsolute} className="d-flex">
                                <Radio
                                    number="ABSOLUTE"
                                    option="2"
                                    name="radioTimeframeOptions"
                                    onChange={this.handleRadio}
                                    value={radioTimeframeOptions}
                                    label={
                                        this.props.context === 'project'
                                            ? t('project:useAbsoluteTimeframe')
                                            : t('report.filter:AbsoluteTimeframe')
                                    }
                                    data-datarange={filterType}
                                    className={this.props.context === 'filterPanel' ? 'radioButtonTimeframe' : 'custom-radio-lg'}
                                    disabled={this.props.isInstanceReport}
                                    tabIndex="0"
                                    labelClass={this.props.context === 'project' ? 'timeframeLbl' : undefined}
                                />
                            </Col>

                            {/* Date Pickers */}
                            {[absoluteStartDate, absoluteEndDate].map((date, idx) => {
                                const isStart = idx === 0;
                                const idSuffix = isStart ? 'startDateAbsolute' : 'endDateAbsolute';
                                const errorMsg = isStart ? absoluteStartError : absoluteEndError;
                                const label = isStart ? t('project:startDate') : t('project:endDate');
                                const onChangeFn = isStart ? this.handleStartDateInputChange : this.handleEndDateInputChange;
                                const validFn = isStart ? this.validAbsoluteStart : this.validAbsoluteEnd;

                                return (
                                    <Col key={idSuffix} {...this.layout.colDateAbsolute}>
                                        <DatePicker
                                            preventOpenOnFocus={true}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    e.target.click(); // triggers calendar open
                                                }
                                            }}
                                            selected={date}
                                            onChange={onChangeFn}
                                            dateFormat={dateFormat}
                                            className={`form-control ${
                                                this.props.context === 'filterPanel' ? 'timeSelectDateInputFilterPanel' : ''
                                            }`}
                                            placeholderText={isStart ? t('report.filter:StartDate') : 'End Date'}
                                            disabled={radioTimeframeOptions !== '2' || this.props.isInstanceReport}
                                            id={`${idSuffix}${filterType}`}
                                            showPopperArrow={true}
                                            popperPlacement="right"
                                            popperProps={{ strategy: 'fixed' }}
                                            filterDate={validFn}
                                            closeOnScroll={true}
                                            showMonthYearPicker={showMonthYearPicker}
                                            showMonthYearDropdown={false}
                                            showYearDropdown={true}
                                            dropdownMode="scroll"
                                        />
                                        <span className={this.props.context === 'filterPanel' ? 'labelText' : 'labelTextLg'}>
                                          {label}
                                        </span>
                                        <Row className="timeSelectError">{errorMsg}</Row>
                                    </Col>
                                );
                            })}

                            {/* Benchmark Summary — aligned with Base Period Start */}
                            <Col md={{ span: this.layout.colBenchmarkSummary.md, offset: this.layout.colSpacer.md }} className="mt-2">
                                {Object.keys(this.props.timeFilter).length > 0 && (
                                    <div className="d-flex align-items-center">
                                      <span className={this.props.context === 'filterPanel' ? 'labelText' : 'labelTextLg'}>
                                        {t('project:benchmarkStringAbsolute', { value: absoluteBenchmarkLabel })}
                                      </span>
                                    </div>
                                )}
                                <div
                                    id={`absoluteTimeWarning${this.props.filterType}`}
                                    className="timeSelectLabel timeSelectWarning d-flex align-items-center"
                                >
                                    <span id={`absoluteTimeWarningText${this.props.filterType}`} className="benchmarkWarning"></span>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </FormGroup>
        )
    }
}

export default withTranslation()(TimeframeSelection);